webpackJsonp([1],{

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventBus", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_properties__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__winapp__ = __webpack_require__(183);










var EventBus = new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]();

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;
__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_properties___default()(__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype, {
  http: {
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_3_axios___default.a;
    }
  },
  $http: {
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_3_axios___default.a;
    }
  },
  $winapp: {
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_7__winapp__["a" /* default */];
    }
  },
  $moment: {
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default.a;
    }
  }
});

new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_5__App___default.a)).$mount('#app');

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(254)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(274),
  /* scopeId */
  "data-v-58c9908b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(256)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(276),
  /* scopeId */
  "data-v-986605cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(280);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    }

    return { x: 0, y: 0 };
  },
  routes: [{
    path: '/',
    name: 'main',
    component: __webpack_require__(264)
  }, {
    path: '/history/:pageId?',
    name: 'history',
    component: __webpack_require__(263)
  }, {
    path: '*',
    redirect: '/'
  }]
}));

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var systemMediaControls;
var castingPicker;
var self = this;

/* harmony default export */ __webpack_exports__["a"] = ({
    init: function init() {
        var audioElement = document.getElementById("radio_stream");
        if (!audioElement) {
            return;
        }

        if (typeof Windows !== "undefined") {
            self = this;
            systemMediaControls = Windows.Media.SystemMediaTransportControls.getForCurrentView();
            systemMediaControls.addEventListener("buttonpressed", this.systemMediaControlsButtonPressed, false);

            systemMediaControls.isPlayEnabled = true;
            systemMediaControls.isPauseEnabled = true;
            systemMediaControls.isStopEnabled = true;

            systemMediaControls.playbackStatus = Windows.Media.MediaPlaybackStatus.closed;

            audioElement.addEventListener("pause", this.mediaPaused);
            audioElement.addEventListener("playing", this.mediaPlaying);
            audioElement.addEventListener("ended", this.mediaEnded);
            this.updateBadgeGlyph("playing");
        }

        if ('mediaSession' in navigator) {
            navigator.mediaSession.setActionHandler('play', this.playMedia);
            navigator.mediaSession.setActionHandler('pause', this.pauseMedia);
        }
    },
    systemMediaControlsButtonPressed: function systemMediaControlsButtonPressed(eventIn) {
        var mediaButton = Windows.Media.SystemMediaTransportControlsButton;

        switch (eventIn.button) {
            case mediaButton.play:
                self.playMedia();
                break;

            case mediaButton.pause:
                self.pauseMedia();
                break;

            case mediaButton.stop:
                self.stopMedia();
                break;

        }
    },
    playMedia: function playMedia() {
        var media = document.getElementById("radio_stream");
        media.play();
    },
    pauseMedia: function pauseMedia() {
        var media = document.getElementById("radio_stream");
        media.pause();
    },
    stopMedia: function stopMedia() {
        var media = document.getElementById("radio_stream");
        media.pause();
        media.currentTime = 0;
    },
    mediaPlaying: function mediaPlaying() {
        systemMediaControls.playbackStatus = Windows.Media.MediaPlaybackStatus.playing;
        self.updateBadgeGlyph("paused");
    },
    mediaPaused: function mediaPaused() {
        systemMediaControls.playbackStatus = Windows.Media.MediaPlaybackStatus.paused;
        self.updateBadgeGlyph("playing");
    },
    mediaEnded: function mediaEnded() {
        systemMediaControls.playbackStatus = Windows.Media.MediaPlaybackStatus.stopped;
        self.updateBadgeGlyph("none");
    },
    updateMediaControls: function updateMediaControls(artistName, trackName, trackArtwork) {
        if (typeof Windows !== 'undefined') {
            var displayUpdater = systemMediaControls.displayUpdater;

            displayUpdater.clearAll();
            displayUpdater.type = Windows.Media.MediaPlaybackType.music;

            displayUpdater.musicProperties.artist = artistName;
            displayUpdater.musicProperties.title = trackName;

            try {
                var uri = new Windows.Foundation.Uri(trackArtwork);
                displayUpdater.thumbnail = Windows.Storage.Streams.RandomAccessStreamReference.createFromUri(uri);
            } catch (err) {
                console.log("Error updating artwork");
                console.log(err);
            }

            displayUpdater.update();

            try {
                this.updateLiveTile(artistName, trackName, trackArtwork);
            } catch (err) {
                console.log(err);
            }
        } else if ('mediaSession' in navigator) {
            navigator.mediaSession.metadata = new MediaMetadata({
                title: trackName,
                artist: artistName,
                artwork: [{ src: trackArtwork, sizes: '512x512', type: 'image/png' }]
            });
        }
    },
    updateLiveTile: function updateLiveTile(artistName, trackName, artwork) {
        if (typeof Windows !== 'undefined') {
            var Notifications = Windows.UI.Notifications;

            var tileUpdater = Notifications.TileUpdateManager.createTileUpdaterForApplication();
            tileUpdater.enableNotificationQueue(false);
            tileUpdater.clear();

            var wideTileXml = Notifications.TileUpdateManager.getTemplateContent(Notifications.TileTemplateType.tileWide310x150PeekImage01);

            var tileAttributes = wideTileXml.getElementsByTagName("text");
            tileAttributes[0].appendChild(wideTileXml.createTextNode(trackName));
            tileAttributes[1].appendChild(wideTileXml.createTextNode(artistName));
            wideTileXml.getElementsByTagName("image")[0].setAttribute("src", artwork);

            var mediumTileXml = Notifications.TileUpdateManager.getTemplateContent(Notifications.TileTemplateType.tileSquarePeekImageAndText01);

            var medTileAttributes = mediumTileXml.getElementsByTagName("text");
            medTileAttributes[0].appendChild(mediumTileXml.createTextNode(trackName));
            medTileAttributes[1].appendChild(mediumTileXml.createTextNode(artistName));
            mediumTileXml.getElementsByTagName("image")[0].setAttribute("src", artwork);

            var combined = wideTileXml.importNode(mediumTileXml.getElementsByTagName("binding").item(0), true);
            wideTileXml.getElementsByTagName("visual").item(0).appendChild(combined);

            var tileNotification = new Notifications.TileNotification(wideTileXml);

            Notifications.TileUpdateManager.createTileUpdaterForApplication().update(tileNotification);
        }
    },
    registerForShare: function registerForShare() {
        try {
            var dataTransferManager = Windows.ApplicationModel.DataTransfer.DataTransferManager.getForCurrentView();
            dataTransferManager.addEventListener("datarequested", shareTextHandler);
        } catch (err) {
            console.log(err);
        }
    },
    shareTextHandler: function shareTextHandler(e) {
        var request = e.request;

        var displayUpdater = systemMediaControls.displayUpdater;

        var artist = displayUpdater.musicProperties.artist;
        var title = displayUpdater.musicProperties.title;

        if (artist.length > 0 && title.length > 0) {
            request.data.properties.title = "Madnight Radio";
            request.data.properties.description = "Share what you're currently listening to on Madnight Radio!";

            request.data.setText("I am currently listening to " + artist + " - " + title + " on Madnight Radio! (http://radio.madnight.co.uk)");
        }
    },
    makeShareButton: function makeShareButton() {
        if ($('.radio-controls.container').find('.share-button').length > 0) {
            return;
        }

        var $shareButton = $('<div>', {
            id: 'showShareButton',
            class: 'share-button',
            html: '<span class="fa fa-comment-o"></span>',
            title: 'Click to share'
        });

        $shareButton.unbind('click').bind('click', function () {
            Windows.ApplicationModel.DataTransfer.DataTransferManager.showShareUI();
        });

        var thing = $('.radio-controls.container');
        thing.append($shareButton);
    },
    setupPlayTo: function setupPlayTo() {

        castingPicker = new Windows.Media.Casting.CastingDevicePicker();
        castingPicker.addEventListener("CastingDeviceSelected", castingDeviceSelectedHandler, false);
    },
    showPlayTo: function showPlayTo() {
        var rect = {
            height: 96,
            width: 64,
            x: 0,
            y: 0
        };

        castingPicker.show(rect);
    },
    sourceRequestHandler: function sourceRequestHandler(e) {
        try {
            var sr = e.sourceRequest;
            var controller;

            try {
                var mediaElement = document.getElementById("radio_stream");
                controller = mediaElement.msPlayToSource;
            } catch (ex) {}

            sr.setSource(controller);
        } catch (ex) {}
    },
    castingDeviceSelectedHandler: function castingDeviceSelectedHandler(e) {
        var connection = e.selectedCastingDevice.createCastingConnection();

        try {
            var mediaElement = document.getElementById("radio_stream");
            controller = mediaElement.msPlayToSource;
            connection.requestStartCastingAsync(controller);
        } catch (ex) {}
    },
    makePlayToButton: function makePlayToButton() {
        var $playToButton = $('<div>', {
            id: 'showplayToButton',
            class: 'playto-button',
            html: '<span class="fa fa-external-link"></span>',
            title: 'Play to connected device'
        });

        $playToButton.unbind('click').bind('click', function () {
            showPlayTo();
        });

        var thing = $('.radio-controls.container');
        thing.append($playToButton);
    },
    updateBadgeGlyph: function updateBadgeGlyph(glyphType) {
        console.log("setting glyp to", glyphType);
        var Notifications = Windows.UI.Notifications;

        var badgeXml = Notifications.BadgeUpdateManager.getTemplateContent(Notifications.BadgeTemplateType.badgeGlpyh);
        var badgeAttributes = badgeXml.getElementsByTagName("badge");
        badgeAttributes[0].setAttribute("value", glyphType);

        var badgeNotification = new Notifications.BadgeNotification(badgeXml);

        Notifications.BadgeUpdateManager.createBadgeUpdaterForApplication().update(badgeNotification);
    }
});

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(257)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(277),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopHeader__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_globals_Player__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_globals_Player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_globals_Player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme__ = __webpack_require__(41);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	components: { TopHeader: __WEBPACK_IMPORTED_MODULE_0__components_TopHeader___default.a, Player: __WEBPACK_IMPORTED_MODULE_1__components_globals_Player___default.a },
	data: function data() {
		return {};
	},
	methods: {
		setPageTitle: function setPageTitle(title) {
			document.getElementsByTagName('title')[0].innerText = 'Madnight Radio - ' + title;
		},
		toggleTheme: function toggleTheme(toggle) {
			if (toggle === true) {
				document.body.classList.add("is-dark");
			} else {
				document.body.classList.remove("is-dark");
			}
		}
	},

	beforeMount: function beforeMount() {
		__WEBPACK_IMPORTED_MODULE_3__theme__["a" /* default */].loadTheme();
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_2__main_js__["EventBus"].$on("toggleTheme", this.toggleTheme);
		__WEBPACK_IMPORTED_MODULE_2__main_js__["EventBus"].$emit("toggleTheme", __WEBPACK_IMPORTED_MODULE_3__theme__["a" /* default */].isDarkModeEnabled());
	}
});

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "history",
  components: {},

  props: {},

  data: function data() {
    return {
      playHistory: [],
      page: 1,
      loading: true
    };
  },


  watch: {
    "$route.params": function $routeParams(to, from) {
      this.page = parseInt(to.pageId);
      this.fetchHistory();
    }
  },

  filters: {
    secure: function secure(val) {
      if (val === null) return "//placehold.it/300x300?text=MR";
      return val.replace("http:", "https:");
    }
  },

  mounted: function mounted() {
    if (this.$route.params.pageId != undefined) this.page = parseInt(this.$route.params.pageId);

    this.fetchHistory();
  },


  methods: {
    fetchHistory: function fetchHistory() {
      var _this = this;

      this.loading = true;
      this.$http.get("https://radioapi.madnight.co.uk/history.php?type=json&page=" + this.page).then(function (response) {
        if (response.data == undefined || response.data == null || response.status !== 200) return;

        response = response.data;

        _this.playHistory = response.history;
        _this.loading = false;
      }).catch(function (error) {
        _this.loading = false;
      });
    },
    getTimePlayed: function getTimePlayed(timestamp) {
      timestamp = timestamp * 1000;
      return this.$moment(timestamp).format("Do MMM YYYY HH:mm:ss");
    },
    getTrackDuration: function getTrackDuration(seconds) {
      var s = {
        hour: 3600000,
        minute: 60000,
        second: 1000
      };

      var timeRemainining = {};
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(s).forEach(function (key) {
        timeRemainining[key] = Math.floor(seconds / s[key]);
        seconds -= timeRemainining[key] * s[key];
      });

      if (timeRemainining["hour"] > 0) return this.pad(timeRemainining["hour"]) + ":" + this.pad(timeRemainining["minute"]) + ":" + this.pad(timeRemainining["seconds"]);

      return this.pad(timeRemainining["minute"]) + ":" + this.pad(timeRemainining["second"]);
    },
    pad: function pad(number) {
      if (number < 10) return "0" + number;

      return number;
    }
  }
});

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_globals_Navbar__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_globals_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_globals_Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_globals_NowPlaying__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_globals_NowPlaying___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_globals_NowPlaying__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_globals_RadioStats__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_globals_RadioStats___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_globals_RadioStats__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_globals_TrackList__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_globals_TrackList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_globals_TrackList__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "home",
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0__components_globals_Navbar___default.a,
    NowPlaying: __WEBPACK_IMPORTED_MODULE_1__components_globals_NowPlaying___default.a,
    RadioStats: __WEBPACK_IMPORTED_MODULE_2__components_globals_RadioStats___default.a,
    TrackList: __WEBPACK_IMPORTED_MODULE_3__components_globals_TrackList___default.a
  },

  props: {},

  data: function data() {
    return {
      playing: {},
      repeatInfo: {},
      radioStats: {
        currentListeners: 0,
        peakListeners: 0,
        averageListenTime: 0,
        streamStatus: 0
      },
      recentlyPlayed: [],
      popularTracks: [],
      loading: true,
      intervals: {
        playing: null,
        stats: null,
        history: null,
        popular: null
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchPlayingTrack();
    this.fetchRadioStats();
    this.fetchHistory();
    this.fetchPopular();

    this.intervals.playing = setInterval(this.fetchPlayingTrack, 5 * 1000);
    this.intervals.stats = setInterval(this.fetchRadioStats, 30 * 1000);
    this.intervals.history = setInterval(this.fetchHistory, 60 * 1000);
    this.intervals.popular = setInterval(this.fetchPopular, 120 * 1000);

    this.$nextTick(function () {
      _this.$winapp.init();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var intervalKey = undefined,
        interval = undefined;
    for (intervalKey in this.intervals) {
      if (this.intervals.hasOwnProperty(intervalKey) === false || !(interval = this.intervals[intervalKey])) {
        continue;
      }

      clearInterval(interval);
    }
  },


  methods: {
    fetchPlayingTrack: function fetchPlayingTrack() {
      var _this2 = this;

      this.$http.get("https://radioapi.madnight.co.uk/shoutcast-vue.php").then(function (response) {
        if (response.data == undefined || response.data == null || response.status !== 200) return;

        _this2.repeatInfo = response.data.repeat_info;

        if (response.data.track_info.artist !== _this2.playing.artist || response.data.track_info.track !== _this2.playing.track || response.data.track_info.game !== _this2.playing.game) {
          _this2.playing = response.data.track_info;
        }

        var lastRepeat = Date.now() - _this2.repeatInfo.last_repeat * 1000;
        lastRepeat /= 1000;

        if (lastRepeat > _this2.repeatInfo.no_repeat_record) {
          _this2.repeatInfo.no_repeat_record = lastRepeat;
        }

        _this2.loading = false;
      });
    },
    fetchRadioStats: function fetchRadioStats() {
      var _this3 = this;

      this.$http.get("https://radiostats.madnight.co.uk/stats?json=true").then(function (response) {
        if (response.data == undefined || response.data == null || response.status !== 200) return;

        response = response.data;

        _this3.radioStats = {
          currentListeners: response.currentlisteners,
          peakListeners: response.peaklisteners,
          averageListenTime: response.averagetime,
          streamStatus: response.streamstatus
        };
      });
    },
    fetchHistory: function fetchHistory() {
      var _this4 = this;

      this.$http.get("https://radioapi.madnight.co.uk/history.php?type=json").then(function (response) {
        if (response.data == undefined || response.data == null || response.status !== 200) return;

        response = response.data;

        _this4.recentlyPlayed = response.history;
      });
    },
    fetchPopular: function fetchPopular() {
      var _this5 = this;

      this.$http.get("https://radioapi.madnight.co.uk/popular.php").then(function (response) {
        if (response.data == undefined || response.data == null || response.status !== 200) return;

        response = response.data;

        _this5.popularTracks = response.popular_tracks;
      });
    }
  }
});

/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_globals_Navbar__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_globals_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_globals_Navbar__);




/* harmony default export */ __webpack_exports__["default"] = ({
	components: { Navbar: __WEBPACK_IMPORTED_MODULE_0__components_globals_Navbar___default.a },
	props: {}
});

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__theme__ = __webpack_require__(41);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'navbar',
	data: function data() {
		return {
			hamburgerOpen: false,
			navItems: [{ link: '/', title: 'Now Playing' }, { link: '/#recent', title: 'Recently Played' }, { link: '/#popular', title: 'Popular Tracks' }, { link: '/history', title: 'History' }],
			themeIcon: "moon"
		};
	},
	mounted: function mounted() {
		var _this = this;

		document.addEventListener('click', function (e) {
			if (e.target.className.indexOf('hamburger') > -1 || e.target.className.indexOf('fa-bars') > -1) return;

			_this.hamburgerOpen = false;
		});

		this.setThemeIcon();
	},


	methods: {
		toggleHamburger: function toggleHamburger() {
			this.hamburgerOpen = !this.hamburgerOpen;
		},
		toggleTheme: function toggleTheme() {
			var currentTheme = __WEBPACK_IMPORTED_MODULE_1__theme__["a" /* default */].isDarkModeEnabled();
			__WEBPACK_IMPORTED_MODULE_1__theme__["a" /* default */].setDarkModeEnabled(!currentTheme);

			__WEBPACK_IMPORTED_MODULE_0__main__["EventBus"].$emit("toggleTheme", !currentTheme);
			this.setThemeIcon();
		},
		setThemeIcon: function setThemeIcon() {
			this.themeIcon = __WEBPACK_IMPORTED_MODULE_1__theme__["a" /* default */].isDarkModeEnabled() === false ? "moon" : "sun";
		}
	}
});

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'nowplaying',
	data: function data() {
		return {};
	},


	props: {
		playing: Object
	},

	watch: {
		playing: {
			deep: true,
			handler: function handler(val) {
				this.$winapp.updateMediaControls(val.artist, val.track, this.secureArtwork(val.artwork));
			}
		}
	},

	filters: {
		secure: function secure(val) {
			if (val === null) return "//placehold.it/300x300?text=MR";
			return val.replace("http:", "https:");
		}
	},

	methods: {
		getLastPlayedDate: function getLastPlayedDate(timestamp) {
			timestamp = timestamp *= 1000;
			var dateObj = new Date(timestamp);

			var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

			return dateObj.getDate() + this.getDateSuffix(dateObj.getDate()) + ' ' + months[dateObj.getMonth()] + ' ' + dateObj.getFullYear();
		},
		getDateSuffix: function getDateSuffix(number) {
			switch (number) {
				case 1:
				case 21:
				case 31:
					return 'st';

				case 2:
				case 22:
					return 'nd';

				case 3:
				case 23:
					return 'rd';
			}

			return 'th';
		},
		secureArtwork: function secureArtwork(val) {
			if (val === null) return "//placehold.it/300x300?text=MR";
			return val.replace("http:", "https:");
		}
	}
});

/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_globals_Timer__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_globals_Timer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_globals_Timer__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'player',

	components: {
		Timer: __WEBPACK_IMPORTED_MODULE_1__components_globals_Timer___default.a
	},

	data: function data() {
		return {
			playing: false,
			muted: false,
			volume: parseFloat(this.fetchSetting('volume')) || 100,
			playtime: 0,
			audio: null
		};
	},


	props: {},

	mounted: function mounted() {
		this.audio = document.getElementById('radio_stream');
		if (this.audio) {
			this.audio.addEventListener('durationchange', this.durationChange);
			this.audio.addEventListener('timeupdate', this.durationChange);
			this.audio.volume = 1 * (this.volume / 100);
		}
	},


	computed: {},

	methods: {
		toggleMute: function toggleMute() {
			if (this.audio == null) return;

			this.muted = !this.muted;
			this.audio.muted = this.muted;
		},
		togglePlaying: function togglePlaying() {
			if (this.audio == null) return;

			this.playing = !this.playing;
			if (this.playing == true) {
				this.audio.play();
			} else {
				this.audio.pause();
			}
		},
		updateVolume: function updateVolume(e) {
			if (this.audio == null) return;

			var clicked = e.offsetX;
			var percent = e.offsetX / 300 * 100;

			this.volume = percent;
			this.audio.volume = 1 * (this.volume / 100);

			if (percent <= 0.0) this.toggleMute();

			this.storeSetting('volume', this.volume);
		},
		durationChange: function durationChange(e) {
			if (e != null && e.timeStamp) this.playtime = parseInt(e.timeStamp / 1000);
		},
		storeSetting: function storeSetting(key, value) {
			if ((typeof localStorage === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(localStorage)) === undefined) return;

			localStorage.setItem(key, value);
		},
		fetchSetting: function fetchSetting(key) {
			if ((typeof localStorage === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(localStorage)) === undefined) return;

			return localStorage[key] || null;
		}
	}
});

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_globals_Timer__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_globals_Timer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_globals_Timer__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'radiostats',

	components: {
		Timer: __WEBPACK_IMPORTED_MODULE_0__components_globals_Timer___default.a
	},

	data: function data() {
		return {};
	},


	props: {
		repeatinfo: Object,
		stats: Object
	},

	methods: {
		getLastRepeatInfo: function getLastRepeatInfo() {
			return this.$moment(this.repeatinfo.last_repeat * 1000).format('[' + this.repeatinfo.last_repeat_artist + ' - ' + this.repeatinfo.last_repeat_track + ' on] MMMM Do YYYY [at] h:mm:ss a');
		},
		shouldRepeatRecordTick: function shouldRepeatRecordTick() {
			var now = new Date().getTime() / 1000,
			    timeSinceLastRepeat = now - this.repeatinfo.last_repeat;
			if (timeSinceLastRepeat >= this.repeatinfo.no_repeat_record) {
				return true;
			}

			return false;
		}
	}
});

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'timer',
	data: function data() {
		return {
			interval: null,
			timeUntil: {},
			startTime: null
		};
	},


	props: {
		timesince: Number,
		countdown: {
			type: Boolean,
			default: true
		},
		info: String,
		shouldtick: {
			type: Boolean,
			default: true
		},
		iscalculated: {
			type: Boolean,
			default: false
		}
	},

	mounted: function mounted() {
		this.tick();
		this.interval = setInterval(this.tick, 1 * 1000);
	},


	watch: {
		timesince: function timesince(newval) {
			this.startTime = null;
		}
	},

	methods: {
		tick: function tick() {
			this.calculateTimeRemaining();
		},

		calculateTimeRemaining: function calculateTimeRemaining() {
			this.timeUntil = {};

			if (this.timesince === 0) {
				return;
			}

			var dateObj = new Date();
			var currentTimestamp = dateObj.getTime();
			var finishTimestamp = this.timesince * 1000;
			var timeRemaining = 0;

			if (this.iscalculated === false) {
				if (this.shouldtick == true) {
					if (this.countdown == true) {
						timeRemaining = Math.abs(currentTimestamp - finishTimestamp);
					} else {
						timeRemaining = Math.abs(finishTimestamp - currentTimestamp);
					}
				} else {
					timeRemaining = finishTimestamp;
				}
			} else {
				timeRemaining = finishTimestamp;
				if (this.shouldtick === true) {
					if (!this.startTime) this.startTime = finishTimestamp;else timeRemaining = this.startTime += 1000;
				}
			}

			if (timeRemaining === 0) {
				return;
			}

			var s = {
				month: 2592000000,
				week: 604800000,
				day: 86400000,
				hour: 3600000,
				minute: 60000,
				second: 1000
			};

			var self = this;
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(s).forEach(function (key) {
				self.timeUntil[key] = Math.floor(timeRemaining / s[key]);
				timeRemaining -= self.timeUntil[key] * s[key];
			});
		}
	},

	filters: {
		pad: function pad(val) {
			if (val < 10) {
				return '0' + val;
			}

			return val;
		}
	}
});

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'tracklist',

	data: function data() {
		return {};
	},


	props: {
		header: String,
		tracks: Array,
		skipfirst: {
			default: false,
			type: Boolean
		},
		longdate: Boolean
	},

	filters: {
		secure: function secure(val) {
			if (val === null) return "//placehold.it/300x300?text=MR";
			return val.replace("http:", "https:");
		}
	},

	methods: {
		getTimestamp: function getTimestamp(timestamp, longDate) {
			var dateObj = new Date(timestamp * 1000);

			if (longDate !== true) return this.pad(dateObj.getHours()) + ":" + this.pad(dateObj.getMinutes()) + ":" + this.pad(dateObj.getSeconds());

			return this.pad(dateObj.getDate()) + "/" + this.pad(dateObj.getMonth() + 1) + "/" + this.pad(dateObj.getFullYear()) + " " + this.pad(dateObj.getHours()) + ":" + this.pad(dateObj.getMinutes()) + ":" + this.pad(dateObj.getSeconds());
		},
		pad: function pad(number) {
			if (number < 10) return "0" + number;

			return number;
		}
	}
});

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 251:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 255:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 256:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 258:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 54,
	"./af.js": 54,
	"./ar": 61,
	"./ar-dz": 55,
	"./ar-dz.js": 55,
	"./ar-kw": 56,
	"./ar-kw.js": 56,
	"./ar-ly": 57,
	"./ar-ly.js": 57,
	"./ar-ma": 58,
	"./ar-ma.js": 58,
	"./ar-sa": 59,
	"./ar-sa.js": 59,
	"./ar-tn": 60,
	"./ar-tn.js": 60,
	"./ar.js": 61,
	"./az": 62,
	"./az.js": 62,
	"./be": 63,
	"./be.js": 63,
	"./bg": 64,
	"./bg.js": 64,
	"./bm": 65,
	"./bm.js": 65,
	"./bn": 66,
	"./bn.js": 66,
	"./bo": 67,
	"./bo.js": 67,
	"./br": 68,
	"./br.js": 68,
	"./bs": 69,
	"./bs.js": 69,
	"./ca": 70,
	"./ca.js": 70,
	"./cs": 71,
	"./cs.js": 71,
	"./cv": 72,
	"./cv.js": 72,
	"./cy": 73,
	"./cy.js": 73,
	"./da": 74,
	"./da.js": 74,
	"./de": 77,
	"./de-at": 75,
	"./de-at.js": 75,
	"./de-ch": 76,
	"./de-ch.js": 76,
	"./de.js": 77,
	"./dv": 78,
	"./dv.js": 78,
	"./el": 79,
	"./el.js": 79,
	"./en-au": 80,
	"./en-au.js": 80,
	"./en-ca": 81,
	"./en-ca.js": 81,
	"./en-gb": 82,
	"./en-gb.js": 82,
	"./en-ie": 83,
	"./en-ie.js": 83,
	"./en-il": 84,
	"./en-il.js": 84,
	"./en-nz": 85,
	"./en-nz.js": 85,
	"./eo": 86,
	"./eo.js": 86,
	"./es": 89,
	"./es-do": 87,
	"./es-do.js": 87,
	"./es-us": 88,
	"./es-us.js": 88,
	"./es.js": 89,
	"./et": 90,
	"./et.js": 90,
	"./eu": 91,
	"./eu.js": 91,
	"./fa": 92,
	"./fa.js": 92,
	"./fi": 93,
	"./fi.js": 93,
	"./fo": 94,
	"./fo.js": 94,
	"./fr": 97,
	"./fr-ca": 95,
	"./fr-ca.js": 95,
	"./fr-ch": 96,
	"./fr-ch.js": 96,
	"./fr.js": 97,
	"./fy": 98,
	"./fy.js": 98,
	"./gd": 99,
	"./gd.js": 99,
	"./gl": 100,
	"./gl.js": 100,
	"./gom-latn": 101,
	"./gom-latn.js": 101,
	"./gu": 102,
	"./gu.js": 102,
	"./he": 103,
	"./he.js": 103,
	"./hi": 104,
	"./hi.js": 104,
	"./hr": 105,
	"./hr.js": 105,
	"./hu": 106,
	"./hu.js": 106,
	"./hy-am": 107,
	"./hy-am.js": 107,
	"./id": 108,
	"./id.js": 108,
	"./is": 109,
	"./is.js": 109,
	"./it": 110,
	"./it.js": 110,
	"./ja": 111,
	"./ja.js": 111,
	"./jv": 112,
	"./jv.js": 112,
	"./ka": 113,
	"./ka.js": 113,
	"./kk": 114,
	"./kk.js": 114,
	"./km": 115,
	"./km.js": 115,
	"./kn": 116,
	"./kn.js": 116,
	"./ko": 117,
	"./ko.js": 117,
	"./ku": 118,
	"./ku.js": 118,
	"./ky": 119,
	"./ky.js": 119,
	"./lb": 120,
	"./lb.js": 120,
	"./lo": 121,
	"./lo.js": 121,
	"./lt": 122,
	"./lt.js": 122,
	"./lv": 123,
	"./lv.js": 123,
	"./me": 124,
	"./me.js": 124,
	"./mi": 125,
	"./mi.js": 125,
	"./mk": 126,
	"./mk.js": 126,
	"./ml": 127,
	"./ml.js": 127,
	"./mn": 128,
	"./mn.js": 128,
	"./mr": 129,
	"./mr.js": 129,
	"./ms": 131,
	"./ms-my": 130,
	"./ms-my.js": 130,
	"./ms.js": 131,
	"./mt": 132,
	"./mt.js": 132,
	"./my": 133,
	"./my.js": 133,
	"./nb": 134,
	"./nb.js": 134,
	"./ne": 135,
	"./ne.js": 135,
	"./nl": 137,
	"./nl-be": 136,
	"./nl-be.js": 136,
	"./nl.js": 137,
	"./nn": 138,
	"./nn.js": 138,
	"./pa-in": 139,
	"./pa-in.js": 139,
	"./pl": 140,
	"./pl.js": 140,
	"./pt": 142,
	"./pt-br": 141,
	"./pt-br.js": 141,
	"./pt.js": 142,
	"./ro": 143,
	"./ro.js": 143,
	"./ru": 144,
	"./ru.js": 144,
	"./sd": 145,
	"./sd.js": 145,
	"./se": 146,
	"./se.js": 146,
	"./si": 147,
	"./si.js": 147,
	"./sk": 148,
	"./sk.js": 148,
	"./sl": 149,
	"./sl.js": 149,
	"./sq": 150,
	"./sq.js": 150,
	"./sr": 152,
	"./sr-cyrl": 151,
	"./sr-cyrl.js": 151,
	"./sr.js": 152,
	"./ss": 153,
	"./ss.js": 153,
	"./sv": 154,
	"./sv.js": 154,
	"./sw": 155,
	"./sw.js": 155,
	"./ta": 156,
	"./ta.js": 156,
	"./te": 157,
	"./te.js": 157,
	"./tet": 158,
	"./tet.js": 158,
	"./tg": 159,
	"./tg.js": 159,
	"./th": 160,
	"./th.js": 160,
	"./tl-ph": 161,
	"./tl-ph.js": 161,
	"./tlh": 162,
	"./tlh.js": 162,
	"./tr": 163,
	"./tr.js": 163,
	"./tzl": 164,
	"./tzl.js": 164,
	"./tzm": 166,
	"./tzm-latn": 165,
	"./tzm-latn.js": 165,
	"./tzm.js": 166,
	"./ug-cn": 167,
	"./ug-cn.js": 167,
	"./uk": 168,
	"./uk.js": 168,
	"./ur": 169,
	"./ur.js": 169,
	"./uz": 171,
	"./uz-latn": 170,
	"./uz-latn.js": 170,
	"./uz.js": 171,
	"./vi": 172,
	"./vi.js": 172,
	"./x-pseudo": 173,
	"./x-pseudo.js": 173,
	"./yo": 174,
	"./yo.js": 174,
	"./zh-cn": 175,
	"./zh-cn.js": 175,
	"./zh-hk": 176,
	"./zh-hk.js": 176,
	"./zh-tw": 177,
	"./zh-tw.js": 177
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(259)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(279),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(250)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(270),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(251)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(271),
  /* scopeId */
  "data-v-17579fb6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(255)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(275),
  /* scopeId */
  "data-v-93d7511a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(252)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(272),
  /* scopeId */
  "data-v-3b518248",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(253)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(273),
  /* scopeId */
  "data-v-47f4065f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(258)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(278),
  /* scopeId */
  "data-v-aa87f444",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 270:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', [_c('NowPlaying', {
    attrs: {
      "playing": _vm.playing
    }
  }), _vm._v(" "), _c('RadioStats', {
    attrs: {
      "repeatinfo": _vm.repeatInfo,
      "stats": _vm.radioStats
    }
  }), _vm._v(" "), _c('TrackList', {
    attrs: {
      "id": "recent",
      "header": "Recently Played",
      "tracks": _vm.recentlyPlayed,
      "skipfirst": true
    }
  }), _vm._v(" "), _c('TrackList', {
    attrs: {
      "id": "popular",
      "header": "Popular Tracks",
      "tracks": _vm.popularTracks,
      "longdate": true
    }
  })], 1) : _c('div', [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('span', {
    staticClass: "fa fa-spinner fa-spin fa-2x"
  }), _vm._v(" "), _c('h1', [_vm._v("Connecting to radio... please wait...")])])
}]}

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('Navbar')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-player"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('div', {
    staticClass: "control play icon",
    on: {
      "click": _vm.togglePlaying
    }
  }, [(!_vm.playing) ? _c('span', {
    staticClass: "fa fa-play"
  }) : _c('span', {
    staticClass: "fa fa-pause"
  })]), _vm._v(" "), _c('div', {
    staticClass: "control play-time"
  }, [_c('Timer', {
    attrs: {
      "timesince": _vm.playtime,
      "countdown": false,
      "shouldtick": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "control sound"
  }, [_c('div', {
    staticClass: "icon",
    on: {
      "click": _vm.toggleMute
    }
  }, [(!_vm.muted) ? _c('div', [_c('span', {
    staticClass: "fa fa-volume-up"
  })]) : _c('div', [_c('span', {
    staticClass: "fa fa-volume-off"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "volume-slide",
    on: {
      "click": _vm.updateVolume
    }
  }, [_c('div', {
    staticClass: "volume-slide-inner",
    style: ({
      width: ((this.volume) + "%")
    })
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('audio', {
    attrs: {
      "id": "radio_stream",
      "msAudioCategory": "backgroundCapableMedia"
    }
  }, [_c('source', {
    attrs: {
      "src": "https://radiostream.madnight.co.uk/;",
      "type": "audio/mpeg"
    }
  })])
}]}

/***/ }),

/***/ 273:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-stats"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("Listeners (Live/Peak)")]), _vm._v(" "), _c('span', {
    staticClass: "stat"
  }, [_vm._v(_vm._s(_vm.stats.currentListeners + " (" + _vm.stats.peakListeners + ")"))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("Average listen time")]), _vm._v(" "), _c('Timer', {
    attrs: {
      "timesince": _vm.stats.averageListenTime,
      "iscalculated": true,
      "countdown": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("Time since last repeat")]), _vm._v(" "), _c('Timer', {
    attrs: {
      "title": _vm.getLastRepeatInfo(),
      "timesince": _vm.repeatinfo.last_repeat,
      "countdown": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("No repeat record")]), _vm._v(" "), _c('Timer', {
    attrs: {
      "timesince": _vm.repeatinfo.no_repeat_record,
      "iscalculated": _vm.shouldRepeatRecordTick(),
      "countdown": false,
      "shouldtick": _vm.shouldRepeatRecordTick()
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 274:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "mr-navbar-container"
  }, [_c('div', {
    staticClass: "mr-badge"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Madnight Radio")]), _vm._v(" "), _c('span', {
    class: ("fa fa-" + _vm.themeIcon + "-o"),
    on: {
      "click": _vm.toggleTheme
    }
  })], 1), _vm._v(" "), _c('div', {
    class: "mr-hamburger" + (this.hamburgerOpen == true ? " is-active" : ""),
    on: {
      "click": _vm.toggleHamburger
    }
  }, [_c('span', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "mr-navbar-items"
  }, _vm._l((_vm.navItems), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "mr-navbar-item"
    }, [(item.nonRouter !== true) ? _c('router-link', {
      attrs: {
        "to": {
          path: item.link
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _c('a', {
      attrs: {
        "href": item.link
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }), 0)])])
},staticRenderFns: []}

/***/ }),

/***/ 275:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.playing != null) ? _c('div', {
    staticClass: "now-playing",
    style: ({
      backgroundImage: _vm.playing.artwork !== null ? ("url('" + (_vm.secureArtwork(_vm.playing.artwork)) + "')") : ""
    })
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.playing.artwork !== null) ? _c('div', {
    staticClass: "artwork"
  }, [_c('img', {
    attrs: {
      "src": _vm._f("secure")(_vm.playing.artwork),
      "alt": _vm.playing.track
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "track-info"
  }, [_c('h1', {
    staticClass: "artist"
  }, [_vm._v(_vm._s(_vm.playing.artist))]), _vm._v(" "), _c('h2', {
    staticClass: "track"
  }, [_vm._v(_vm._s(_vm.playing.track))]), _vm._v(" "), (_vm.playing.game) ? _c('h3', {
    staticClass: "game"
  }, [_vm._v(_vm._s(_vm.playing.game))]) : _vm._e()]), _vm._v(" "), (_vm.playing.stats && _vm.playing.stats.hasOwnProperty('is_new')) ? _c('div', {
    staticClass: "track-stats",
    class: {
      'no-artwork': !_vm.playing.artwork
    }
  }, [(_vm.playing.stats.is_new === true) ? _c('span', {
    staticClass: "plays tag is-primary is-medium is-new-track"
  }, [_vm._v("New")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_c('a', {
    attrs: {
      "href": ("https://last.fm/music/" + (_vm.playing.artist) + "/_/" + (_vm.playing.track)),
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-lastfm"
  }), _vm._v("Purchase on last.fm")])]), _vm._v(" "), (_vm.playing.stats && _vm.playing.stats.is_new !== true) ? [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "plays"
  }, [_vm._v(_vm._s(_vm.playing.stats.play_count + " play" + (_vm.playing.stats.play_count == 1 ? "" : "s")))]), _vm._v(" "), _c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "last-played"
  }, [_vm._v(_vm._s("Last played: " + _vm.getLastPlayedDate(_vm.playing.stats.last_played)))])] : _vm._e()], 2) : _vm._e()])]) : _c('div', {
    staticClass: "now-playing loading"
  })
},staticRenderFns: []}

/***/ }),

/***/ 276:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timer"
  }, [_c('div', [(_vm.timeUntil.month) ? _c('span', {
    staticClass: "timer-val month"
  }, [_vm._v(_vm._s(_vm.timeUntil.month) + "m ")]) : _vm._e(), _vm._v(" "), (_vm.timeUntil.week) ? _c('span', {
    staticClass: "timer-val week"
  }, [_vm._v(_vm._s(_vm.timeUntil.week) + "w ")]) : _vm._e(), _vm._v(" "), (_vm.timeUntil.day) ? _c('span', {
    staticClass: "timer-val day"
  }, [_vm._v(_vm._s(_vm.timeUntil.day) + "d ")]) : _vm._e(), _vm._v(" "), (_vm.timeUntil.hour) ? _c('span', {
    staticClass: "timer-val hour"
  }, [_vm._v(_vm._s(_vm.timeUntil.hour) + "h")]) : _vm._e(), _vm._v(" "), (_vm.timeUntil.minute) ? _c('span', {
    staticClass: "timer-val minute"
  }, [_vm._v(_vm._s(_vm.timeUntil.minute) + "m")]) : _vm._e(), _vm._v(" "), (_vm.timeUntil.second >= 0) ? _c('span', {
    staticClass: "timer-val second"
  }, [_vm._v(_vm._s(_vm.timeUntil.second) + "s")]) : _c('span', [_vm._v("0h 0m 0s")])])])
},staticRenderFns: []}

/***/ }),

/***/ 277:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('top-header', {
    on: {
      "toggleTheme": _vm.toggleTheme
    }
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('player')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 278:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "track-list"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.header) ? _c('h1', [_vm._v(_vm._s(this.header))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "tracks"
  }, _vm._l((_vm.tracks), function(track, index) {
    return ((_vm.skipfirst == true && index != 0) || _vm.skipfirst == false) ? _c('li', {
      key: index,
      class: {
        extended: track.plays > 0
      }
    }, [_c('a', {
      attrs: {
        "href": ("https://last.fm/music/" + (track.artist) + "/_/" + (track.track)),
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "artwork"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("secure")(track.artwork),
        "alt": track.track
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "track-time"
    }, [_c('span', [_vm._v(_vm._s(_vm.getTimestamp(track.timestamp, _vm.longdate)))])]), _vm._v(" "), (track.plays) ? _c('div', {
      staticClass: "track-plays"
    }, [_c('span', [_vm._v(_vm._s(track.plays + " play" + (track.plays == 1 ? "" : "s")))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "track-info"
    }, [_c('h1', [_vm._v(_vm._s(track.artist))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(track.track))])])])]) : _vm._e()
  }), 0)])])
},staticRenderFns: []}

/***/ }),

/***/ 279:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-history"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Track History")]), _vm._v(" "), (_vm.playHistory && _vm.playHistory.length > 0 && _vm.loading == false) ? [_c('table', [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.playHistory), function(track, index) {
    return (index !== 0) ? _c('tr', {
      key: index
    }, [_c('td', [(track.artwork != null) ? [_c('img', {
      attrs: {
        "src": _vm._f("secure")(track.artwork),
        "alt": ((track.artist) + " - " + (track.track))
      }
    })] : [_c('img', {
      attrs: {
        "src": "//placehold.it/300x300?text=MR"
      }
    })]], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTimePlayed(track.timestamp)))]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(track.artist))]), _vm._v(" "), (track.game) ? _c('span', {
      staticClass: "game"
    }, [_vm._v(_vm._s(track.game))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(track.track))]), _vm._v(" "), _c('td', {
      staticClass: "time"
    }, [(track.duration > 0) ? _c('span', [_vm._v(_vm._s(_vm.getTrackDuration(track.duration)))]) : _c('span', [_vm._v("N/A")])])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('router-link', {
    staticClass: "load-more button is-primary",
    attrs: {
      "to": {
        path: ("/history/" + (this.page + 1))
      }
    }
  }, [_vm._v("Load more")])] : (_vm.loading == true) ? [_vm._m(1)] : [_c('h4', [_vm._v("There's nothing here!")])]], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Time/Date")]), _vm._v(" "), _c('th', [_vm._v("Artist")]), _vm._v(" "), _c('th', [_vm._v("Track")]), _vm._v(" "), _c('th', {
    staticClass: "time"
  }, [_vm._v("Duration")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('span', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" "), _c('span', [_vm._v("Fetching history, hang tight...")])])
}]}

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(15);


var _this = this;



/* harmony default export */ __webpack_exports__["a"] = ({
    darkMode: false,

    isDarkModeEnabled: function isDarkModeEnabled() {
        return _this.darkMode;
    },

    setDarkModeEnabled: function setDarkModeEnabled(enabled) {
        if ((typeof localStorage === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(localStorage)) === undefined) {
            return;
        }

        _this.darkMode = enabled;
        localStorage.setItem("darkTheme", _this.darkMode);
    },

    loadTheme: function loadTheme() {
        _this.darkMode = JSON.parse(localStorage.getItem("darkTheme")) || false;
        return _this.darkMode;
    }
});

/***/ })

},[15]);


// WEBPACK FOOTER //
// static/js/app.84fa0414ccee346894a4.js